import useStateStore from 'services/store';
import './home.scss';
import Collar from 'components/FloatConfigurator/Collar/Collar';
import {
    InnerFabric,
    BackPleats,
    Monogram,
    Placket,
    Pocket,
    Stitch,
    Fabric,
    Cuff,
} from 'components/FloatConfigurator';
import Button from 'components/Button/Button';
import InformationContainer from 'components/InformationContainer/InformationContainer';
import SelectedFabric from 'components/SelectedFabric/SelectedFabric';
import Configurator from 'components/Configurator/Configurator';
import SelectFabricForm from 'components/SelectFabricForm/SelectFabricForm';
import { useEffect, useState } from 'react';
import { getProcedures } from 'services/utils';

function getWindowDimensions() {
    const { innerWidth: width, innerHeight: height } = window;
    return {
        width,
        height,
    };
}
function handleResize() {
    const dims = getWindowDimensions();
    const proc = getProcedures();
    if (proc?.changeFOV) {
        if (dims.width < 540) {
            proc?.changeFOV('mobile-portrait');
        } else {
            proc?.changeFOV('others');
        }
    }
}
const Home = () => {
    const {
        changeInforFormState,
        isLoading,
        setAddMoreShirt,
        isAddMoreShirt,
        addNewProduct,
        activeProductData,
    } = useStateStore();
    const [askingForm, setAskingForm] = useState(false);
    const resetCameraPosition = () => {
        const procedure = getProcedures();
        if (procedure && procedure.resetCamera) {
            procedure.resetCamera();
        }
    };

    useEffect(() => {
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    // useEffect(() => {
    //     function handlePostMessage(event: MessageEvent) {
    //         if (event.data?.state === 'resize') {
    //             handleResize();
    //         }
    //     }
    //     window.addEventListener('message', handlePostMessage);
    //     return () => window.removeEventListener('message', handlePostMessage);
    // }, []);

    const handleClickAskingForm = (state: boolean) => {
        if (!state) {
            changeInforFormState(true);
            setAddMoreShirt(false);
        } else {
            addNewProduct();
            setAddMoreShirt(true);
        }
        setAskingForm(false);
    };
    const checkForAskingForm = (state: boolean) => {
        if (Object.keys(activeProductData).length < 3 && !isAddMoreShirt) {
            setAskingForm(state);
        } else {
            changeInforFormState(true);
        }
    };
    return (
        <div className="home-container">
            <div className={`loading-container ${isLoading ? 'show' : ''}`}>
                <span className="loading-circle"></span>
            </div>
            <div className={`dialog ${askingForm ? 'show' : ''}`}>
                <div className="ovelay"></div>
                <div className="content">
                    <div>Would you like to design another shirt with same features?</div>
                    <div className="btn-container">
                        <Button
                            onClick={() => handleClickAskingForm(true)}
                            children={'Yes'}
                        ></Button>
                        <Button
                            onClick={() => handleClickAskingForm(false)}
                            variant="teriary"
                            children={'No'}
                        ></Button>
                    </div>
                </div>
            </div>
            <InformationContainer />
            <SelectFabricForm />
            <div onClick={() => checkForAskingForm(true)} className="btn-submit">
                <Button
                    isIcon="right"
                    icon={<img src="images/configurator/arrow-right-white.svg" alt="" />}
                >
                    NEXT
                </Button>
            </div>
            <Configurator />
            <div className="model-container">
                <SelectedFabric />
                <FloatConfigurator />
                <iframe
                    id="iframe_model"
                    className="iframe"
                    title="fr"
                    src="./models/3dmodel/index.html"
                />
            </div>
            <button className="reset-camera" onClick={() => resetCameraPosition()}>
                <img src="./images/refresh.svg" alt="Reset Camera" />
            </button>
        </div>
    );
};

const FloatConfigurator = () => {
    const { currentConfig } = useStateStore();
    if (currentConfig === 'collar') {
        return <Collar />;
    } else if (currentConfig === 'fabric') {
        return <Fabric />;
    } else if (currentConfig === 'cuff') {
        return <Cuff />;
    } else if (currentConfig === 'inner-fabric') {
        return <InnerFabric />;
    } else if (currentConfig === 'collar') {
        return <Collar />;
    } else if (currentConfig === 'monogram') {
        return <Monogram />;
    } else if (currentConfig === 'stitch') {
        return <Stitch />;
    } else if (currentConfig === 'placket') {
        return <Placket />;
    } else if (currentConfig === 'pocket') {
        return <Pocket />;
    } else if (currentConfig === 'back-pleats') {
        return <BackPleats />;
    } else {
        return <></>;
    }
};

export default Home;
